import { arrayToObject } from 'lib/arrayUtils'
import { useMemo, useState } from 'react'

export default function useStateWithSetters<const S extends string>(
  values: Array<S>,
  initialState: S | (() => S),
) {
  const [state, setState] = useState<S>(initialState)

  const setters = useMemo(() => {
    return arrayToObject(
      values,
      (val) => val,
      (val) => () => setState(val),
    ) as { [K in S]: () => void }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, values)

  return [state, setters, setState] as [S, typeof setters, typeof setState]
}
